<!--
 * @Author: M.D.
 * @Date: 2019-12-18 10:37:05
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="user-center">
    <div class="upper bShadow-5">
      <div class="uc-img">
        <div class="uc-img-w bShadow-10">
          <img :src="tImgUrl(userInfo.avatar)" :onerror="errImgDefault" style="width:100%; height:100%" />
        </div>
      </div>
      <div class="info">
        <div class="username">{{memberInfo.username}}
          <el-button type="success" style="margin-left: 14px; background-color:#3D3C3F; color:#FFE778; border-color:#3D3C3F" v-if="memberInfo.isVip" round>VIP用户</el-button>
        </div>
        <div class="point" v-if="!memberInfo.isVip">我的积分：<span class="num">{{memberInfo.point}}</span>分</div>
        <div class="point" v-if="memberInfo.isVip">VIP有效期至：{{ memberInfo.vipValidTime.split(' ')[0]}}<p style="margin-left: 18px">剩余会员免费培训次数：{{ memberInfo.vipSurplusTimes }}</p></div>
      </div>
      <div class="btn">
          <el-button type="success" v-if="!memberInfo.isVip" round @click="vipOrder">成为VIP</el-button>
          <!-- <el-button type="success" style="background-color:#3D3C3F; color:#FFE778; border-color:#3D3C3F" v-if="memberInfo.isVip" round>VIP用户</el-button> -->
          <el-button type="success" v-else round @click="vipOrder">续费延长VIP</el-button>
      </div>
    </div>

    <!-- 已购买的产品 -->
    <div class="order-list bShadow-5">
      <div class="list-wrapper">
        <div class="uc-w-h">
          <div class="uc-l">购买的产品</div>
          <!--<div>
            <el-button type="false"   @click="vipOrder">调整顺序保存</el-button>
          </div>-->
          <div class="uc-r" @click="goToOrderPage">查看更多 >></div>
        </div>
        <ui-product-list :productList="recentProducts" @productUpdate="productUpdate"></ui-product-list>
      </div>
    </div>
  </div>
</template>

<script>
import UiProductList from '@/components/ui-product-list'
import { mapGetters } from 'vuex'
import API from '@/api/api'

export default {
  name: 'user',
  props: {

  },
  data () {
    return {
      recentProducts: []
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'memberInfo'])
  },
  created () {

  },
  mounted () {
    this.initPage()
    this.$store.dispatch('getMemberInfo')
  },
  activated () {

  },
  deactivated () {

  },
  watch: {

  },
  methods: {
    productUpdate () {
      this.initPage()
    },
    async vipOrder () {
      this.orderVipPrd(this.userInfo.cityCode, this)
      this.$router.push({
        name: 'userVipPrd'
      })
    },
    async initPage () {
      const productsRlt = await API.getMyProducts({
        memberId: this.userInfo.id,
        currentPage: 1,
        pageSize: 4
      })
      this.recentProducts = productsRlt.data.result.records
      // console.log(this.recentProducts)
    },
    goToOrderPage () {
      // this.$router.push({ name: 'orders', params: { } })
    }
  },
  components: {
    UiProductList
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.user-center
  &>div
    background-color #ffffff
    box-sizing border-box
    padding 20px
  .upper
    margin-bottom 20px
    display flex
    position relative
    .uc-img
      flex 0 0 160px
      height 70px
      center()
      .uc-img-w
        height 70px
        width 70px
        font-size 0
        border-radius 50%
        overflow hidden
      // background-color green
    .info
      flex 0 0 auto
      // background-color red
      &>div
        padding-left 50px
        box-sizing border-box
        height 50%
        flex-left()
      .username
        color #333333
        font-size 20px
      .point
        color #999999
        font-size 16px
        .num
          color theme-color
          font-size 18px
          padding 0px 12px 0px 8px
    .btn
      flex 1 1 auto
      flex-left()
      padding-left 100px
      box-sizing border-box
      // background-color black
  .order-list
    min-height 536px
    padding-top 12px
    .uc-w-h
      height 46px
      line-height 46px
      flex-ltr-parent()
      border-bottom 1px solid #dddddd
      &>div
        padding 0px 10px
        font-size 14px
      .uc-l
        font-size 18px
        color #333333
      .uc-r
        color #999999
    .list
      width 100%
      .uc-item
        width 100%
        height 130px
        border-bottom 1px solid #dddddd
        box-sizing border-box
        padding 12px
        display flex
        &:last-child
          border-bottom none
        .uc-img-sec
          flex 0 0 160px
          center()
          overflow hidden
          .uc-goods-w
            goods-img-wrapper()
            img
              goods-img-image()
        .uc-info
          flex 0 0 320px
          box-sizing border-box
          padding 5px 10px
          // background-color green
          .p-name
            max-width 320px
            ellipsis2(2)
            line-height 24px
            font-size 16px
            color #333333
          .sub-name
            color #999999
            height 45px
            font-size 12px
            leftBottom()
        .price
          flex 0 0  200px
          // background-color yellow
          center()
          font-size 18px
        .status
          flex 0 0 200px
          position relative
          center()
          .main-txt
            height 100%
            color orange-color
            text-align center
          .uc-sub-txt
            margin-top 10px
            text-align center
            width 100%
            color #999999
            font-size 12px
        .handler
          flex 1 1 auto
          .handler-wrapper
            height 100%
            columnCenter()
</style>
